import React from 'react';
import { Route, Redirect } from 'react-router';
import Layout from './components/Layout';
import MetadataProvider from './components/MetadataProvider';
import AboutPage from './components/AboutPage';
import HousingFootprintPage from './components/HousingFootprintPage';
import HousingPage from './components/HousingPage';
import PlacePage from './components/PlacePage';
import LinksPage from './components/LinksPage';
import PlaceList from './components/PlaceList';
import Homepage from './components/Homepage';
import HomepageCaribbean from './components/HomepageCaribbean';
import SearchPage from './components/SearchPage';
import NotFoundPage from './components/NotFoundPage';
import ForecastEmbed from "./components/ForecastEmbed";
import ComparisonEmbed from "./components/ComparisonEmbed";
import ImpactsEmbed from "./components/ImpactsEmbed";
import NuisanceFloodingEmbed from "./components/NuisanceFloodingEmbed";
import RegionEAEEmbed from "./components/RegionEAEEmbed";
import ZillowEmbed from "./components/ZillowEmbed";

const routes = (
  <Route>
    <Route path="/embed" searchable={true} component={MetadataProvider} >
      <Route path="forecast-img/:placeType/:placeID" component={ForecastEmbed}/>
      <Route path="impact-comparison-img/:placeType/:placeID" component={ComparisonEmbed}/>
      <Route path="impact-table-img/:placeType/:placeID" component={ImpactsEmbed}/>
      <Route path="fairweather-flood-img/:placeType/:placeID" component={NuisanceFloodingEmbed}/>
      <Route path="eae-img/:placeType/:placeID" component={RegionEAEEmbed}/>
      <Route path="housing-img/:placeType/:placeID" component={ZillowEmbed}/>
    </Route>
    <Route component={Layout}>
      <Route path="/" component={Homepage} />

      {/* TODO: disable Ecuador pages using regex after moving to later version of React Router */}
      <Route path="/country/ecuador" component={NotFoundPage} />
      <Route path="/canton/espejo.cr.ec" component={NotFoundPage} />
      <Route path="/canton/guayaquil.gu.ec" component={NotFoundPage} />
      <Route path="/canton/quito.pi.ec" component={NotFoundPage} />
      <Route path="/province/guayas.ec" component={NotFoundPage} />
      <Route path="/province/pichincha.ec" component={NotFoundPage} />

      <Route path="/housing" component={HousingPage} />
      <Route path="/housing-footprint" component={HousingFootprintPage} />
      <Route path="/caribbean" component={HomepageCaribbean} />
      <Route path="/saint-kitts-and-nevis" component={Homepage} />
      <Route path="/barbados" component={Homepage} />
      <Route path="/grenada" component={Homepage} />
      <Route path="/guyana" component={Homepage} />
      <Route path="/antigua-and-barbuda" component={Homepage} />
      <Route path="/saint-vincent-and-the-grenadines" component={Homepage} />
      <Route path="/panama" component={Homepage} />
      <Route path="/dominican-republic" component={Homepage} />
      <Route path="/trinidad-and-tobago" component={Homepage} />
      <Route path="/jamaica" component={Homepage} />
      <Route path="/nicaragua" component={Homepage} />
      <Route path="/haiti" component={Homepage} />
      <Route path="/bahamas" component={Homepage} />
      <Route path="/suriname" component={Homepage} />
      <Route path="/bangladesh" component={Homepage} />
      <Route path="/dominica" component={Homepage} />
      <Route path="/saint-lucia" component={Homepage} />
      <Route path="/search" component={SearchPage} />
      <Route path="/about" searchable={true} component={AboutPage} />
      <Route path="/links" searchable={true} component={LinksPage} />
      <Route component={MetadataProvider} >
        <Route path="/:placeType" searchable={true} component={PlaceList} />
        <Route path="/:placeType/:placeID" searchable={true} component={PlacePage} />
      </Route>
      <Route path="/notfound" component={NotFoundPage} />
    </Route>
  </Route>
);

export default routes;
